import React, { Component } from "react";
import { connect } from "react-redux";
import { userActions } from "../../_actions";
import InputBox from "./InputBox";

class EmployeeLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      otp_code: "",
      showLogin: true,
      failureMSG: "",
      saveSuccess: false,
    };
  }

  /* ---------------- EMAIL CHANGE ---------------- */
  inputChangeEmail = (e) => {
    this.setState({ email: e.target.value, failureMSG: "" });
  };

  /* ---------------- OTP CHANGE ---------------- */
  inputChangeOTP = (e) => {
    this.setState({ otp_code: e.target.value, failureMSG: "" });
  };

  /* ---------------- EMAIL VALIDATION ---------------- */
  validateEmail = (email) => {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  /* ---------------- SEND OTP ---------------- */
  submitEmail = () => {
    if (this.handleValidationLogin()) {
      let { email } = this.state;
      if (email) {
        this.setState({ showEmailSuccessful: true });

        this.props.dispatch(
          userActions.userEmployeeLogin({ email: email }, this.props)
        );
        this.setState({ failureMSG: "", showLogin: false });

        setTimeout(() => {
          this.setState({ showEmailSuccessful: false });
        }, 3000);
      }
    }
  };

  handleValidationLogin = () => {
    console.log(
      "Get otpGet otpGet otpGet otpGet otpGet otpGet otpGet otpGet otpGet otp VALIDATION:::"
    );

    function validateEmail(email) {
      const re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    // let email = this.state;
    let failureMSG = this.state;
    let formIsValid = true;

    //email
    if (this.state.email === "") {
      formIsValid = false;
      failureMSG = "Please enter your email";
    } else {
      if (!validateEmail(this.state.email)) {
        formIsValid = false;
        failureMSG = "Please enter valid email";
      }
    }
    this.setState({ failureMSG: failureMSG });
    return formIsValid;
  };
  /* ---------------- VERIFY OTP ---------------- */
  OTPSubmit = () => {
    const { user } = this.props;
    const { UserAssessmentEmailToken, UserAssessmentType } = user;
    console.log("user:----------->", user)

    console.log("UserAssessmentEmailToken:----------->", UserAssessmentEmailToken)
    console.log("UserAssessmentType:----------->", UserAssessmentType)

    let { otp_code } = this.state;

    let failureMSG = "";
    let formIsValid = true;

    let data = {
      token: UserAssessmentEmailToken,
      otp: otp_code,
    };
    //otp_code
    if (this.state.otp_code === "") {
      formIsValid = false;
      failureMSG = "Please enter your OTP";
    } else {
      this.setState({ failureMSG: "" });
      this.setState({ saveSuccess: true });
      // if (UserAssessmentType) {
      // } else {
      //   this.props.dispatch(userActions.userAssessmentValidateOtp(data, this.props));
      // }
      this.props.dispatch(userActions.userEmployeeValidateOtp(data, this.props));

    }
    this.setState({ failureMSG: failureMSG });

    setTimeout(() => {
      this.setState({ saveSuccess: false });
    }, 4000);
  };


  /* ---------------- RESEND OTP ---------------- */
  reSendOtp = () => {
    this.submitEmail();
  };

  /* ---------------- CHANGE EMAIL ---------------- */
  changeEmail = () => {
    this.setState({
      email: "",
      otp_code: "",
      showLogin: true,
      failureMSG: "",
    });
  };

  /* ---------------- ENTER KEY ---------------- */
  _handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.state.showLogin ? this.submitEmail() : this.OTPSubmit();
    }
  };

  render() {
    const { email, otp_code, showLogin, failureMSG, saveSuccess } = this.state;
    const { user } = this.props;

    const {
      userEmployeeValidateOtpSuccess,
      userEmployeeValidateOtpFailure,
    } = user;

    return (
      <>
        <div className="bg-white flex justify-center items-center h-screen">
          {/* LEFT IMAGE */}
          <div className="w-1/2 h-screen hidden lg:block">
            <img
              src="/img/insightplus-login.webp"
              alt="Login"
              className="object-cover w-full h-full"
            />
          </div>

          {/* RIGHT SECTION */}
          <div className="flex w-full md:w-1/2 items-center justify-center px-6 md:px-16 py-12">
            <div className="w-full max-w-lg flex-1">
              <div className="mb-10">
                {/*<img
                  src="/img/TalentPlusStrengths_logo.svg"
                  alt="TalentPlusStrengths"
                  className="h-14"
                />*/}
              </div>

              {/* EMAIL SCREEN */}
              {showLogin ? (
                <>
                  <h1 className="text-4xl font-bold text-gray-900 mb-10">Welcome back!</h1>
                  <h1 className="text-3xl font-semibold text-gray-900 mb-2">Sign in</h1>
                  <p className="text-gray-500 text-sm mb-10">Enter your email address, We will send you an OTP to verify.</p>

                  <InputBox
                    label="Email Address"
                    name="email"
                    type="email"
                    placeholder="Enter email"
                    value={email}
                    onChange={this.inputChangeEmail}
                    onKeyDown={this._handleKeyDown}
                  />

                  {failureMSG && (
                    <p className="text-red-500 text-sm mt-2">{failureMSG}</p>
                  )}

                  <button
                    onClick={this.submitEmail}
                    className="w-full mt-6 bg-indigo-600 text-white font-medium py-3 rounded-md"
                  >
                    Send Verification Code
                  </button>

                  {saveSuccess && (
                    <p className="text-green-600 text-sm mt-3">
                      OTP sent successfully!
                    </p>
                  )}
                </>
              ) : (
                <>
                  {/* OTP SCREEN */}
                  <h1 className="text-4xl font-bold text-gray-900 mb-2">Verification</h1>
                  <div className="flex items-center justify-between mb-10">
                    <p className="text-gray-500 text-sm whitespace-nowrap">OTP sent to: <b>{email}</b></p>
                    <button onClick={this.changeEmail} className="text-indigo-600 hover:text-indigo-700 text-sm font-semibold">
                      Change
                    </button>
                  </div>

                  <InputBox
                    label="Enter OTP"
                    name="otp"
                    type="text"
                    placeholder="Enter OTP"
                    value={otp_code}
                    onChange={this.inputChangeOTP}
                    onKeyDown={this._handleKeyDown}
                  />

                  {failureMSG && (
                    <p className="text-red-500 text-sm mt-2">{failureMSG}</p>
                  )}

                  {userEmployeeValidateOtpFailure && (
                    <p className="text-red-500 text-sm mt-2">
                      Invalid OTP
                    </p>
                  )}

                  {userEmployeeValidateOtpSuccess && (
                    <p className="text-green-600 text-sm mt-2">
                      OTP verified successfully!
                    </p>
                  )}

                  <button
                    onClick={this.OTPSubmit}
                    className="w-full mt-6 bg-indigo-600 text-white font-medium py-3 rounded-md"
                  >
                    Verify OTP
                  </button>

                  <div className="flex items-center justify-between mt-6 text-sm">
                    <button className="text-gray-600">Didn’t receive OTP?</button>
                    <button onClick={this.reSendOtp} className="text-indigo-600 hover:text-indigo-700 font-semibold border px-6 py-2 border-indigo-600 rounded-md">
                      Resend OTP
                    </button>
                  </div>
                </>
              )}
            </div>

            <div className="absolute bottom-4 right-6">
              <p className="text-xs text-gray-500">
                All Rights Reserved | © InsightPlus 2026.
              </p>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state;
  return { user };
}

export default connect(mapStateToProps)(EmployeeLogin);